<template>
    <div class="mobile-header">
        <header class="header d-flex">
            <router-link to="/mobile" class="header__brand"></router-link>
            <nav class="header__nav">{{ titleByRouteMetaName }}</nav>
            >
            <div class="menu__icon" @click="menuShow = !menuShow"></div>
            <div v-show="menuShow" class="menu__list">
                <the-aside-menu :menu-list="navList" @change="onChange" />
                <div class="menu__list__line"></div>
                <the-aside-menu v-if="login" :menu-list="navList1" @change="onChange" />
                <the-aside-menu v-else :menu-list="navList2" @change="onChange" />
                <div v-if="login" class="menu__list__out" @click="loginOut">退出登录</div>
            </div>
        </header>
    </div>
</template>

<script>
import { logout, notifiy } from '@/service/user';
import theAsideMenu from './components/the-aside-menu';

export default {
    name: 'MobileHeader',
    components: {
        theAsideMenu
    },
    data() {
        return {
            login: false,
            menuShow: false,
            navList: [
                {
                    id: '/m/',
                    isLeaf: true,
                    level: null,
                    routeName: '指令集开发者社区',
                    title: '首页',
                    children: []
                },
                {
                    id: '/m/article',
                    isLeaf: false,
                    level: null,
                    routeName: '文章',
                    title: '文章',
                    children: [
                        {
                            id: '/m/article?tab=systemDevelopment',
                            isLeaf: true,
                            level: null,
                            title: '系统开发',

                            children: []
                        },
                        {
                            id: '/m/article?tab=dataTools',
                            isLeaf: true,
                            level: null,
                            title: '数据工具',
                            children: []
                        },
                        {
                            id: '/m/article?tab=equipmentIntegration',
                            isLeaf: true,
                            level: null,
                            title: '设备集成',
                            children: []
                        },
                        {
                            id: '/m/article?tab=activitySalon',
                            isLeaf: true,
                            level: null,
                            title: '活动沙龙',
                            children: []
                        }
                    ]
                },
                {
                    id: '/m/issue',
                    isLeaf: false,
                    level: null,
                    routeName: '问答',
                    title: '问答',
                    children: [
                        {
                            id: '/m/issue?tab=systemDevelopment',
                            isLeaf: true,
                            level: null,
                            title: '系统开发',
                            children: []
                        },
                        {
                            id: '/m/issue?tab=dataTools',
                            isLeaf: true,
                            level: null,
                            routeLink: 'mobile-issue',
                            title: '数据工具',
                            children: []
                        },
                        {
                            id: '/m/issue?tab=equipmentIntegration',
                            isLeaf: true,
                            level: null,
                            title: '设备集成',
                            children: []
                        }
                    ]
                },
                {
                    id: '/m/document',
                    isLeaf: true,
                    level: null,
                    routeName: '文档',
                    title: '文档',
                    children: []
                },
                {
                    id: '/m/download',
                    isLeaf: true,
                    level: null,
                    routeName: '下载',
                    title: '下载中心',
                    children: []
                },
                {
                    id: '/m/open-source',
                    isLeaf: true,
                    level: null,
                    routeName: '开源组件',
                    title: '开源组件',
                    children: []
                },
                {
                    id: '/m/contact',
                    isLeaf: true,
                    level: null,
                    routeName: '联系我们',
                    title: '联系我们',
                    children: []
                }
            ],
            navList1: [
                {
                    id: '/m/user-center',
                    isLeaf: true,
                    level: null,
                    routeName: '个人中心',
                    title: '个人中心',
                    children: []
                }
            ],
            navList2: [
                {
                    id: '/m/login',
                    isLeaf: true,
                    level: null,
                    routeName: '登录/注册',
                    title: '登录/注册',
                    children: []
                }
            ]
        };
    },
    computed: {
        titleByRouteMetaName() {
            return this.$route.meta.title;
        },
        navActiveRouteName() {
            const lastName = this.$route.name;

            if (/文章/.test(lastName)) return '文章';
            if (/问答/.test(lastName)) return '问答';
            if (/文档/.test(lastName)) return '文档';
            if (/下载/.test(lastName)) return '下载';

            return '';
        }
    },
    watch: {
        '$store.state.user.userInfo': {
            handler(value) {
                if (value.token) {
                    this.login = true;
                } else {
                    this.login = false;
                }
            },
            deep: true,
            immediate: true
        }
    },

    methods: {
        onChange(index) {
            if (index === '/m/document') {
                window.open('https://support.isyscore.com/');
                return;
            }
            this.$router.push({ path: index });
        },

        returnTop() {
            document.getElementsByTagName('html')[0].scrollTop = 0;
        },

        loginOut() {
            this.$dialog
                .confirm({
                    message: '确定要退出登录？',
                    confirmButtonColor: '#047aff',
                    confirmButtonText: '再想想',
                    cancelButtonText: '确定',
                    cancelButtonColor: 'rgba(0, 0, 0, 0.8)'
                })
                .catch(() => {
                    // on confirm
                    this.$store.dispatch('user/signOut');
                    this.$router.push({ name: 'mobileLogin', query: { from: this.$route.fullPath } });
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.mobile-header {
    background: #2d2d2d;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 9;
}

.header {
    width: 100vw;
    height: 60px;
    position: relative;

    &__brand {
        margin-left: 20px;
        margin-top: 18px;
        background: url('../../../../assets/mobile-imgs/logo.png') center center no-repeat;
        width: 28px;
        height: 24px;
        background-size: 100%;
        flex-shrink: 0;
    }

    &__nav {
        margin-left: 16px;
        font-size: 18px;
        font-weight: 600;
        color: white;
        line-height: 60px;
    }
}

.menu__icon {
    position: absolute;
    right: 18px;
    top: 20px;
    background: url('../../../../assets/mobile-imgs/menu-icon.png') center center no-repeat;
    width: 24px;
    height: 24px;
    background-size: 100%;
    flex-shrink: 0;
    cursor: pointer;
}
.menu__list {
    width: 160px;
    position: absolute;
    top: 52px;
    right: 18px;
    padding: 10px 0;
    background: white;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    &__line {
        margin: 10px auto;
        width: 120px;
        height: 1px;
        background: rgba(0, 0, 0, 0.1);
    }

    &__out {
        margin-left: 38px;
        margin-bottom: 14px;
        line-height: 40px;
    }
}
</style>
